<div [ngClass]="{'hasBackgroundBlur': hasBackgroundBlur}" class="table-action-buttons">
  <div class="table-action-buttons-template">
    <ng-container *ngTemplateOutlet="actionButtonsTemplate"></ng-container>
  </div>

  @if (hasClearAllButton) {
    <div class="button-container">
      <button (click)="clearAllFiltersClick.emit()"
        class="btn-secondary clear-all-filters-button"
        data-cy="table-clear-all-filters-button">Clear all filters
      </button>
    </div>
  }
</div>

@if (hasSecondHeader) {
  <app-table-label
    [hasBoldSeparator]="$safeNavigationMigration(tableData?.labels?.hasInnerBoldBorder)"
    [labels]="$safeNavigationMigration(tableData?.labels?.labelsData)"
    [numLines]="tableLinesLength">
  </app-table-label>
}

<app-table-header [headers]="$safeNavigationMigration(tableData?.headers)"
  [expandableLines]="$safeNavigationMigration(tableData?.expandableLines)"
  [excludedColumns]="state.excludedColumns"
  [columnStyles]="columnStyles"
  [initiallySortedBy]="initiallySortedBy"
  (sortedBy)="sortBy($event)">
</app-table-header>

<div class="table-body" [ngClass]="{'min-height': !hasPopulatedBody}">
  @if (hasPopulatedBody) {
    <ng-container *ngTemplateOutlet="populatedTableBody"></ng-container>
  } @else {
    @if (hasNoResultBody) {
      <div class="table-body-no-results" data-cy="table-body-no-results">
        <div class="table-body-no-results-wrapper">
          <img src="../../../../../assets/img/search/search-no-results.svg" class="table-body-no-results-icon"/>
          <div class="table-body-no-results-label">There are no results for your search</div>
        </div>
      </div>
    } @else {
      <div class="table-body-empty">
        <div class="table-body-empty-icon"><span class="iwp-icon-iwp_task"></span></div>
        <div class="table-body-empty-description">The {{tableName}} is empty</div>
      </div>
    }
  }
  @if (showTableBodyLoadingSpinner) {
    <app-loading-spinner
    [ngClass]="{'table-body-spinner-container': hasPopulatedBody}"></app-loading-spinner>
  }
</div>

<!-- No results table body template -->

<!-- Empty table body template -->

<!-- Populated table body template -->
<ng-template #populatedTableBody>
  <div class="table-body-section" data-cy="table-body-static-section">
    @if (tableData.staticSection != null) {
      @for (line of tableData.staticSection; track line; let i = $index) {
        <ng-container *ngTemplateOutlet="tableLine; context: {line: line, index: i}"></ng-container>
      }
    }
  </div>

  @if (hasTableBodySectionSeparator) {
    <div class="table-section-separator"></div>
  }

  @if (tableData.dynamicSection != null) {
    <div class="table-body-section" data-cy="table-body-dynamic-section">
      @if (!showDynamicSectionEmptyTableTemplate) {
        @for (line of tableData.dynamicSection; track line; let i = $index) {
          <ng-container *ngTemplateOutlet="tableLine; context: {line: line, index: i}"></ng-container>
        }
      } @else {
        <div class="table-body-empty">
          <div class="table-body-empty-icon"><span class="iwp-icon-iwp_task"></span></div>
          <div class="table-body-empty-description">The {{tableName}} is empty</div>
        </div>
      }
    </div>
  }
</ng-template>

<!-- Table body section line template -->
<ng-template #tableLine let-line="line" let-index="index">
  <div [ngClass]="getStylesClass(line, tableData.expandableLines)" [attr.data-cy]=getDataCyLineElement(index)
    [attr.data-scrollTo]=getScrollToLineElement(line)>
    <app-table-line #tableLineComponent
      [line]="line"
      [id]="line.identifier"
      [dataPipes]="retrieveDataPipesMap()"
      [hasDot]="retrieveHasDotMap()"
      [hasTextAlignRight]="retrieveHasTextAlignRightMap()"
      [hasFloatContent]="retrieveHasFloatContentMap()"
      [hasCopyPasteButton]="retrieveHasCopyPasteMap()"
      [expandableLine]="tableData.expandableLines"
      [fullLineTooltipDetail]="tableData.expandableLineTooltipDetail"
      [columnStyles]="columnStyles"
      [excludedColumns]="state.excludedColumns"
      [lineIsSelected]="line.isOpen"
      [isBlurred]="lineHasBackgroundBlur(line)"
      [accordionLineTemplate]="accordionLineTemplate"
      [scrollEvent]="scrollEvent"
      [disableAccordion]="disableAccordion"
      [lineAvailableActions]="$safeNavigationMigration(tableData?.tableLineAvailableActions)"
      [hasAnimation]="lineIsAnimated(line)"
      [hasMouseHover]="lineIsMouseHover(line)"
      [hasHighlight]="line.isLineHighlight"
      (isMouseHoverLine)="changeOpenLineBackgroundStyle($event, line)"
      (isMouseLeaveLine)="changeMouseHoverLineBackgroundStyle($event, line)"
      (accordionStatusChange)="accordionStatusChange(line, $event, tableLineComponent)">
    </app-table-line>
  </div>
</ng-template>


@if (hasBackgroundBlur) {
  <div class="background-blur open" [ngClass]="{'allTableBackgroundBlur' : hasAllTableBackgroundBlur}"></div>
}
